import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Slider from "react-slick";
import styles from "./TestimonialsSection.module.scss";
import TestimonialSliderItems from "./TestimonialsSectionSlider";
import "./slickStyle.scss";
function WorksSection({ reviews }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  };
  return (
    <div className={styles["testimonials-section-box"]}>
      <div>
        <Slider {...settings}>
          {!!reviews &&
            reviews.map((data) => {
              return <TestimonialSliderItems {...data} />;
            })}
        </Slider>
      </div>
    </div>
  );
}
export default WorksSection;
